$(document).ready(function () {
	footerPadding(0);

	// Automatically adjust footer padding on screen resize (debounced).
	var resizeTimer;
	$(window).on('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			footerPadding(0);
		}, 100);
	});
});

// (Start) Pushes Footer so that there are no empty white spaces if the elements on page are too short/little.
function footerPadding(extra_height) {
	var $footer = $('#futurelab_global_footer');
	var $body = $('#futurelab_global_body');
	var $padding = $('#futurelab_global_footer_padding');
	if ($footer.length === 0 || $body.length === 0 || $padding.length === 0) {
		return; // Required elements not found; nothing to do.
	}

	// Account for a fixed/sticky top header if present (e.g., 65px navbar)
	var header_height = $('#futurelab_global_header').outerHeight(true) || 0;

	// Reset padding before measuring so its current height doesn't affect calculations
	$padding.css('height', '0px');

	var footer_height = $footer.outerHeight(true) || 0;
	var body_height = $body.outerHeight(true) || 0;
	// Use window.innerHeight when available for better mobile accuracy
	var window_height = window.innerHeight || $(window).height() || 0;

	var extra = Number(extra_height) || 0;
	var available_height = window_height - header_height;
	var total_height = footer_height + body_height + extra;

	var difference = Math.max(0, available_height - total_height);
	$padding.css('height', difference + 'px');
}

// (End)

window.footerPadding = footerPadding;